<template>
  <v-row no-gutters align="center">
    <v-col>
      <v-timeline dense>
        <v-timeline-item
          v-for="(workflowLog, index) in this.workflowLogs"
          :key="workflowLog.id"
          small
        >
          <v-row dense>
            <v-col cols="3">
              {{ workflowLog.toStatus.name }}
            </v-col>
            <v-col>
              {{
                $moment(workflowLog.createdAt, "YYYY-MM-DD HH:mm:ss ZZ")
                  | moment("DD/MM/YYYY")
              }}
            </v-col>
            <v-col>
              {{
                $moment(workflowLog.createdAt, "YYYY-MM-DD HH:mm:ss ZZ")
                  | moment("HH:mm:ss")
              }}
            </v-col>
            <v-col cols="5">
              {{ calculatePatientActionTime(index) }}
            </v-col>
          </v-row>
        </v-timeline-item>
      </v-timeline>
    </v-col>
  </v-row>
</template>

<script>
import GET_TIME_WORKFLOWLOGS from "@/graphql/attendance/workflow_log/workflow_logs.gql";

export default {
  name: "PatientTime",
  props: {
    attendanceId: String,
  },
  data() {
    return {
      patientTime: Array,
    };
  },
  created() {
    this.$apollo.queries.workflowLogs.refetch();
  },
  apollo: {
    workflowLogs: {
      query: GET_TIME_WORKFLOWLOGS,
      variables() {
        return {
          attendanceId: this.attendanceId,
        };
      },
    },
  },
  methods: {
    calculatePatientActionTime(actionIndex) {
      const action = this.workflowLogs[actionIndex];
      const nextAction = this.workflowLogs[actionIndex + 1];
      const actionDate = this.$moment(action.createdAt);
      let nextActionDate;

      if (nextAction) {
        nextActionDate = this.$moment(nextAction.createdAt);
      } else {
        nextActionDate = this.$moment();
        if (!actionDate.isSame(nextActionDate, "day")) {
          return "Atendimento não finalizado no mesmo dia";
        }
      }

      const duration = this.$moment.duration(nextActionDate.diff(actionDate));
      return this.formatDuration(duration);
    },

    formatDuration(duration) {
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      return `${hours} horas, ${minutes} minutos, ${seconds} segundos`;
    },
  },
};
</script>
